const { fetchSingle: fetchSingleSection } = window.BAO.sectionRenderer
const { getElements } = window.BAO.Utils

class QuickAdd extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.listeners.add(document, 'click', this.handleTrigger)
  }

  async handleTrigger (event) {
    try {
      const target = event.target
      const trigger = target.closest('[data-quick-add-external-el="trigger"]')

      if (!trigger || trigger.getAttribute('aria-busy') === 'true') return

      trigger.setAttribute('aria-busy', true)

      const productUrl = trigger.dataset.productUrl

      const response = await fetchSingleSection('quick-add', productUrl)

      const newDOM = window.BAO.sectionRenderer.convertToDOM(response)
      const bodyContent = newDOM.querySelector('.sec-QuickAdd')

      // Update product form Nosto type for analytics
      const productCard = target.closest('product-card')
      const nostoType = productCard.dataset.nostoType

      if (nostoType) {
        const productForms = getElements('[data-push-cart-form]', {
          context: bodyContent,
        })

        const placementId = trigger.closest('.nosto_element')?.id

        productForms.forEach((formEl) => {
          formEl.dataset.nostoType = nostoType

          if (placementId) {
            formEl.dataset.nostoPlacementId = placementId
          }
        })
      }

      // Update body
      this.els.body.element.innerHTML = bodyContent.outerHTML
      trigger.setAttribute('aria-busy', false)

      window.drawers.activeDrawerKey = 'quick-add'
    } catch (error) {
      window.drawers.activeDrawerKey = ''
      console.error(error)
    }
  }
}

if (!customElements.get('quick-add')) {
  customElements.define('quick-add', QuickAdd)
}
